export const ManeuverFormProperties = {
  MANEUVER_TYPE: 'maneuverType',
  REF_APPROACH_LANE: 'refApproachLane',
  REF_DEPARTURE_LANE: 'refDepartureLane',
  ICON: 'icon',
};

export const MANEUVER_ZOOM = 16;
